export default function RefreshIcon(props) {
  return (
    <svg
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.16699 8.83333C2.16699 8.83333 3.83781 6.55685 5.19519 5.19854C6.55257 3.84022 8.42832 3 10.5003 3C14.6425 3 18.0003 6.35786 18.0003 10.5C18.0003 14.6421 14.6425 18 10.5003 18C7.08108 18 4.19625 15.7119 3.29346 12.5833M2.16699 8.83333V3.83333M2.16699 8.83333H7.16699"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
